document.addEventListener('DOMContentLoaded', function () {
    const savedAddress = sessionStorage.getItem('selectedAddress');
    const savedLatitude = sessionStorage.getItem('latitude');
    const savedLongitude = sessionStorage.getItem('longitude');
    const adresInput = document.getElementById('adres');

    if (savedAddress) {
        adresInput.value = savedAddress;
        document.getElementById('latitude').value = savedLatitude;
        document.getElementById('longitude').value = savedLongitude;
    }

    function updateSurfacePlotVisibility(resetSurfacePlotValue = true) {
        const propertyType = document.getElementById('propertyType').value;
        const surfacePlotInput = document.getElementById('surfacePlot');
        const surfacePlotContainer = document.getElementById('surfacePlotContainer');
        const buildableAreaContainer = document.getElementById('buildableAreaContainer');

        if (propertyType === 'HOUSE') {
            surfacePlotContainer.style.display = 'block';
            surfacePlotInput.required = true;
            if (buildableAreaContainer) {
                buildableAreaContainer.classList.remove('md:col-span-2');
            }
            if (resetSurfacePlotValue) {
                surfacePlotInput.value = '';
            }
        } else {
            surfacePlotContainer.style.display = 'none';
            surfacePlotInput.required = false;
            surfacePlotInput.value = '';
            if (buildableAreaContainer) {
                buildableAreaContainer.classList.add('md:col-span-2');
            }
        }
    }

    function showError(inputElement, message) {
        const id = inputElement.id;
        let messageElement = document.getElementById(id + '-error');
        if (!messageElement) {
            messageElement = document.createElement('div');
            messageElement.id = id + '-error';
            messageElement.className = 'text-red-500 text-sm mt-2';
            inputElement.parentNode.insertBefore(messageElement, inputElement.nextSibling);
        }
        messageElement.textContent = message;
        inputElement.classList.add('border', 'border-red-500');
    }
    
    function clearError(inputElement) {
        inputElement.classList.remove('border', 'border-red-500');
        const errorElement = document.getElementById(inputElement.id + '-error');
        if (errorElement) {
            errorElement.remove();
        }
    }

    updateSurfacePlotVisibility();

    // Alle velden die we willen valideren, met hun eigen foutmelding
    const fields = [
        { id: 'buildableArea',            message: 'Voer de bewoonbare oppervlakte in.' },
        { id: 'bedroomCountNumber',       message: 'Voer het aantal slaapkamers in.' },
        { id: 'energyConsumptionPerSqm',  message: 'Voer de energiescore in.' },
        { id: 'surfacePlot',              message: 'Voer de oppervlakte van het perceel in.' },
        { id: 'propertyType',             message: 'Selecteer het type eigendom.' },
        { id: 'buildingCondition',        message: 'Selecteer de staat van het gebouw.' },
        { id: 'epcLabel',                 message: 'Selecteer het EPC label.' }
    ];

    // Clear foutmeldingen wanneer de gebruiker typt
    fields.forEach(function (field) {
        const element = document.getElementById(field.id);
        if (element) {
            element.addEventListener('input', function () {
                clearError(element);
                element.setCustomValidity('');
            });

            element.addEventListener('invalid', function (event) {
                event.preventDefault();
                showError(element, field.message);
            });
        }
    });

    // Als userContext wordt gewijzigd (radio selecteren), haal fout weg
    document.querySelectorAll('input[name="userContext"]').forEach(radio => {
        radio.addEventListener('change', function() {
            const radioError = document.getElementById('userContext-error');
            if (radioError) {
                radioError.remove();
            }
            updateSaleIntentVisibility();
        });
    });

    function shouldAskSaleIntent(userContext) {
        return userContext === 'OWNER' || userContext === 'INHERITED_OR_MANAGING';
    }

    function updateSaleIntentVisibility() {
        const chosenRadio = document.querySelector('input[name="userContext"]:checked');
        const saleIntentContainer = document.getElementById('saleIntentContainer');
        const shouldShow = chosenRadio && shouldAskSaleIntent(chosenRadio.value);

        if (!saleIntentContainer) return;

        saleIntentContainer.classList.toggle('hidden', !shouldShow);
        if (!shouldShow) {
            document.querySelectorAll('input[name="saleIntent"]').forEach(radio => {
                radio.checked = false;
            });
            const saleIntentError = document.getElementById('saleIntent-error');
            if (saleIntentError) {
                saleIntentError.remove();
            }
        }
    }

    document.querySelectorAll('input[name="saleIntent"]').forEach(radio => {
        radio.addEventListener('change', function() {
            const saleIntentError = document.getElementById('saleIntent-error');
            if (saleIntentError) {
                saleIntentError.remove();
            }
        });
    });

    updateSaleIntentVisibility();

    // Submit-handler voor de validatie
    document.getElementById('property-info-form')
            .addEventListener('submit', function (evt) {
        evt.preventDefault(); // Voorkom direct submitten

        let formIsValid = true;

        // 1) Check elk veld
        fields.forEach(field => {
            const el = document.getElementById(field.id);
            if (field.id === 'surfacePlot' && document.getElementById('propertyType').value !== 'HOUSE') {
                clearError(el);
                return;
            }
            clearError(el);
            // Check of er iets is ingevuld
            if (!el.value) {
                showError(el, field.message);
                formIsValid = false;
            }
        });

        // 2) Check de radio-group (userContext)
        const chosenRadio = document.querySelector('input[name="userContext"]:checked');
        if (!chosenRadio) {
            let radioContainer = document.getElementById('userContext');
            let radioError = document.getElementById('userContext-error');
            if (!radioError) {
                radioError = document.createElement('div');
                radioError.id = 'userContext-error';
                radioError.className = 'text-red-500 text-sm mt-2';
                radioContainer.appendChild(radioError);
            }
            radioError.textContent = 'Gelieve een optie te selecteren.';
            formIsValid = false;
        } else {
            const radioError = document.getElementById('userContext-error');
            if (radioError) radioError.remove();
        }

        const selectedUserContext = chosenRadio ? chosenRadio.value : '';
        const chosenSaleIntent = document.querySelector('input[name="saleIntent"]:checked');
        if (shouldAskSaleIntent(selectedUserContext) && !chosenSaleIntent) {
            let saleIntentContainer = document.getElementById('saleIntentContainer');
            let saleIntentError = document.getElementById('saleIntent-error');
            if (!saleIntentError) {
                saleIntentError = document.createElement('div');
                saleIntentError.id = 'saleIntent-error';
                saleIntentError.className = 'text-red-500 text-sm mt-2';
                saleIntentContainer.appendChild(saleIntentError);
            }
            saleIntentError.textContent = 'Gelieve een optie te selecteren.';
            formIsValid = false;
        } else {
            const saleIntentError = document.getElementById('saleIntent-error');
            if (saleIntentError) saleIntentError.remove();
        }

        // 3) Als alles OK is, géén ouderwetse submit, 
        //    laat index.js de rest (fetch + redirect) afhandelen
        if (formIsValid) {
            // Hier niets doen -> index.js heeft óók een submit-handler 
            // waar de fetch + redirect gebeurt.
            return;
        }
    });
});
